export enum IconClasses {
  error = 'toast-error',
  info = 'toast-info',
  success = 'toast-success',
  warning = 'toast-warning',
}
